<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="fmhead"><i>Dedication</i></p>
<p class="introtxt"><i>This book is dedicated to all the creative people out there who bring such beauty into our lives.</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_dedication.vue?18c0188a